import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import MiniLoading from '../../Components/MiniLoading'
import Slider from '../../Assets/Images/CrearCotizacion/sliders.svg'
import search from '../../Assets/Images/BuscarCotizacion/search.svg'
import ProductList from '../../Components/ProductList'
import no from '../../Assets/Images/Product/No.svg'
import Departments from '../../Views/Departments'
import { useSelector, useDispatch } from 'react-redux'
import './productSearch.css'
import {
  addFacetFilter,
  addCategories,
  addBrands,
  removeSingleCategory,
  removeFacetFilters,
  removeSingleBrand,
  showProductsList,
} from '../../redux/actions/productActions'
import { clearList } from '../../redux/actions/listActions'
import { t } from 'i18next'
import {
  typesenseQueryAction,
  getPriceInventoryGeneral,
} from 'redux/actions/priceProductsAction'
import { fetchPriceInventory } from 'Utils/functions'
import { toTestId } from 'Utils/Helpers/toTestId'
import { TYPESENSE_SEARCH } from 'Utils/constants'
import { applyPriceFilter as applyPriceFilterLogic } from 'Utils/priceFilterUtils'

function ProductSearch({
  productsRef,
  inListScreen,
  setShowMaterialsCalculatorPDP,
  setProductDetail,
  onListCleared,
}) {
  const [productSearchText, setProductSearchText] = useState('')
  const [isSearchable, setIsSearchable] = useState(false)
  const [productSearch, setProductSearch] = useState('')
  const [products, setProducts] = useState([])
  const [newCategories, setNewCategories] = useState(false)
  const currentPage = useRef(0)

  const [showDepartments, setShowDepartments] = useState(true)
  const dispatch = useDispatch()

  const channelRef = useRef(null)
  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }
  const channel = channelRef.current

  const facetFiltersState = useSelector(state => state.products.facetFilters)
  const CompanyCode = useSelector(state => state?.company?.CompanyCode)
  let categoriesRef = []
  let brandsRef = []
  const priceChecked = useRef(0)
  const [priceFiltersState, setPriceFiltersState] = useState('')
  const [priceFilterTrigger, setPriceFilterTrigger] = useState(false)
  const [minInput, setMinInput] = useState('')
  const [maxInput, setMaxInput] = useState('')
  const [showFullCategories, setShowFullCategories] = useState(false)
  const [showFullBrands, setShowFullBrands] = useState(false)
  const [page, setPage] = useState(0)
  const currentNbPages = useRef(0)

  const [checkedCategories, setCheckedCategories] = useState(new Set())
  const [checkedBrands, setCheckedBrands] = useState(new Set())
  const requestIdRef = useRef(0)
  const HITS_PER_PAGE = TYPESENSE_SEARCH.HITS_PER_PAGE
  const searchBodyInitialState = {
    q: '*',
    page: 1,
    per_page: HITS_PER_PAGE,
    preset: TYPESENSE_SEARCH.PRESET,
    facet_by: TYPESENSE_SEARCH.FACET_BY,
    filter_by: '',
  }

  const [searchTrigger, setSearchTrigger] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [categorySearchTrigger, setCategorySearchTrigger] = useState(false)
  const [brandSearchTrigger, setBrandSearchTrigger] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const [hasSearchHits, setHasSearchHits] = useState(true)
  const [categories, setCategories] = useState([])
  const [currentCategory, setCurrentCategory] = useState([])
  const [currentBrand, setCurrentBrand] = useState([])
  const [brands, setBrands] = useState([])
  const [currentDepartment, setCurrentDepartment] = useState(null)
  const [productsLoading, setProductsLoading] = useState(false)
  const CompanyId = useSelector(state => state?.company?.CompanyId)

  const warehouse = useSelector(state => state.company.WarehouseId)

  const handleDepartmentSearch = (state, facetFilter) => {
    setShowDepartments(state)
    setCurrentDepartment(facetFilter.name)
    dispatch(addFacetFilter(facetFilter))
    setNewCategories(true)
    setIsSearchable(true)
    setSearchTrigger(true)
    currentPage.current = 0
  }

  const handleSlider = () => {
    setIsActive(!isActive)
  }

  const handleCategory = e => {
    if (e.target.checked) {
      const facetFilterPayload = {
        key: 'category',
        value: `Category:${e.target.name}`,
      }
      setCheckedCategories(prev => new Set([...prev, e.target.name]))
      setCurrentCategory([...currentCategory, e.target.name])
      dispatch(addCategories(e.target.name))
      dispatch(addFacetFilter(facetFilterPayload))
      setProducts([])
      currentPage.current = 0
      setCategorySearchTrigger(true)
      setIsSearchable(true)
    } else {
      handleRemoveCategory(e.target.name)
    }
  }

  const handleBrands = e => {
    if (e.target.checked) {
      const facetFilterPayload = {
        key: 'brand',
        value: `Brand:${e.target.name}`,
      }
      setCheckedBrands(prev => new Set([...prev, e.target.name]))
      setCurrentBrand([...currentBrand, e.target.name])
      dispatch(addBrands(e.target.name))
      dispatch(addFacetFilter(facetFilterPayload))
      setProducts([])
      setProductSearch('')
      setProductSearchText('')
      currentPage.current = 0
      setBrandSearchTrigger(true)
      setIsSearchable(true)
    } else {
      handleRemoveBrand(e.target.name)
    }
  }

  const handleRemovePriceFilter = () => {
    setPriceFiltersState('')
    setPriceFilterTrigger(false)
  }

  const handlePriceFilter = e => {
    switch (e.target.value) {
      case t('PRODUCTS_SEARCH_T.FINAL_PRICE_CATALOG.FINAL_PRICE_0_19'):
        priceChecked.current = 1
        break
      case t('PRODUCTS_SEARCH_T.FINAL_PRICE_CATALOG.FINAL_PRICE_20_199'):
        priceChecked.current = 2
        break
      case t('PRODUCTS_SEARCH_T.FINAL_PRICE_CATALOG.FINAL_PRICE_200_499'):
        priceChecked.current = 3
        break
      case t('PRODUCTS_SEARCH_T.FINAL_PRICE_CATALOG.FINAL_PRICE_500_799'):
        priceChecked.current = 4
        break
      case t('PRODUCTS_SEARCH_T.FINAL_PRICE_CATALOG.FINAL_PRICE_800'):
        priceChecked.current = 5
        break
      case t('PRODUCTS_SEARCH_T.DISCOUNT_CATALOG.DISCOUNT_1_19'):
        priceChecked.current = 6
        break
      case t('PRODUCTS_SEARCH_T.DISCOUNT_CATALOG.DISCOUNT_20_29'):
        priceChecked.current = 7
        break
      case t('PRODUCTS_SEARCH_T.DISCOUNT_CATALOG.DISCOUNT_30'):
        priceChecked.current = 8
        break
      default:
        priceChecked.current = 0
    }
    let priceFilterPayload = ''
    if (e.target.checked) {
      priceFilterPayload = `${e.target.value}`
      setProducts([])
      setMinInput('')
      setMaxInput('')
      setPriceFiltersState(priceFilterPayload)
      setPriceFilterTrigger(true)
      setIsSearchable(true)
      currentPage.current = 0
    } else if (!e.target.checked) {
      handleRemovePriceFilter()
      setProducts([])
      setProductSearch('')
      setProductSearchText('')
      setPriceFilterTrigger(true)
      setIsSearchable(true)
      priceChecked.current = 0
      currentPage.current = 0
    }
  }

  const handleRemoveCategory = categoryToRemove => {
    if (
      currentBrand.length < 1 &&
      currentCategory.length === 1 &&
      currentDepartment === null
    ) {
      handleRemoveDepartment()
    }
    setCheckedCategories(prev => {
      const next = new Set(prev)
      next.delete(categoryToRemove)
      return next
    })
    const currentCategoryArray = [...currentCategory]
    currentCategoryArray.splice(
      currentCategoryArray.indexOf(categoryToRemove),
      1
    )
    setCurrentCategory([...currentCategoryArray])
    dispatch(removeSingleCategory(categoryToRemove))
    setProducts([])
    setProductSearch('')
    currentPage.current = 0
    setCategorySearchTrigger(true)
  }

  const handleRemoveBrand = brandToRemove => {
    if (
      currentBrand.length === 1 &&
      currentCategory.length < 1 &&
      currentDepartment === null
    ) {
      handleRemoveDepartment()
    }
    setCheckedBrands(prev => {
      const next = new Set(prev)
      next.delete(brandToRemove)
      return next
    })
    const currentBrandArray = [...currentBrand]
    currentBrandArray.splice(currentBrandArray.indexOf(brandToRemove), 1)
    setCurrentBrand([...currentBrandArray])
    dispatch(removeSingleBrand(brandToRemove))
    setProducts([])
    setProductSearch('')
    currentPage.current = 0
    setBrandSearchTrigger(true)
  }

  const handlePage = () => {
    setPage(page + 1)
    currentPage.current++
  }

  const handleMinMax = e => {
    let priceFilterPayload = ''
    if (e.keyCode === 13) {
      if (minInput !== '' && maxInput === '') {
        priceFilterPayload = `${t(
          'PRODUCTS_SEARCH_T.COMPANY_FILTER_LABEL'
        )} >= ${minInput}`
      } else if (minInput === '' && maxInput !== '') {
        priceFilterPayload = `${t(
          'PRODUCTS_SEARCH_T.COMPANY_FILTER_LABEL'
        )} <= ${maxInput}`
      } else if (minInput !== '' && maxInput !== '') {
        priceFilterPayload = `${t(
          'PRODUCTS_SEARCH_T.COMPANY_FILTER_LABEL'
        )}${':'} ${minInput} ${t('PRODUCTS_T.TO_LABEL')} ${maxInput}`
      }
      if (priceFilterPayload !== '') {
        priceChecked.current = 0
        setProducts([])
        setPriceFiltersState(priceFilterPayload)
        setPriceFilterTrigger(true)
        setIsSearchable(true)
        currentPage.current = 0
      }
    }
  }

  const getPrices = async PriceInventoryPayload => {
    setProductsLoading(true)
    try {
      const response = await dispatch(
        getPriceInventoryGeneral(PriceInventoryPayload)
      )
      setProductsLoading(false)
      return response.data?.Data
    } catch (error) {
      console.error('Error:', error)
      setProductsLoading(false)
      return []
    }
  }

  const productList = products => {
    return products.filter(product => product.FinalPrice !== undefined)
  }
  // Backslashes and backticks inside a value would otherwise break out of
  // the quoted Typesense array syntax, so they're escaped before quoting.
  // The backslash must be escaped first, or a value ending in "\" would
  // escape the closing backtick added below instead of terminating the value.
  const quoteFilterValue = value =>
    `\`${String(value).replaceAll('\\', '\\\\').replaceAll('`', '\\`')}\``

  const buildFilterClause = (field, values) =>
    values.length
      ? `${field}:=[${values.map(quoteFilterValue).join(',')}]`
      : null

  const buildFilterBy = () => {
    const deptValues = (
      facetFiltersState.find(f => f.key === 'department')?.value || []
    ).map(v => v.replace('Department:', ''))
    const catValues = (
      facetFiltersState.find(f => f.key === 'category')?.value || []
    ).map(v => v.replace('Category:', ''))
    const brandValues = (
      facetFiltersState.find(f => f.key === 'brand')?.value || []
    ).map(v => v.replace('Brand:', ''))
    return [
      buildFilterClause('Department', deptValues),
      buildFilterClause('Category', catValues),
      buildFilterClause('Brand', brandValues),
    ]
      .filter(Boolean)
      .join(' && ')
  }

  const applyPriceFilter = products => {
    if (!priceFiltersState) return products
    return applyPriceFilterLogic(products, {
      priceCode: priceChecked.current,
      minInput,
      maxInput,
    })
  }

  const postNoHitsMessage = () => {
    channel.postMessage({
      isLoading: false,
      listProducts: [],
      hasSearchHits: false,
      isSearchProducts: true,
    })
  }

  const fetchProducts = async () => {
    // Guards against an older, slower request overwriting the results of a
    // newer one (e.g. the user changes the search/filters before the
    // previous request resolves).
    const requestId = ++requestIdRef.current
    const isStale = () => requestId !== requestIdRef.current

    setProductsLoading(true)
    channel.postMessage({
      isLoading: true,
      isSearchProducts: true,
      listProducts: [],
      productCart: [],
    })

    try {
      const typesenseParams = {
        ...searchBodyInitialState,
        q: productSearch || '*',
        page: currentPage.current + 1,
        filter_by: buildFilterBy(),
      }

      const response = await dispatch(typesenseQueryAction(typesenseParams))
      if (isStale()) return

      // On the first page, an empty/failed response means there's nothing
      // to show. On a later ("load more") page, it just means we've reached
      // the end of the results — the products already on screen (and on the
      // customer display) should stay as they are.
      const isFirstPage = currentPage.current === 0

      if (!response?.data) {
        console.error('Error fetching products from Typesense')
        if (isFirstPage) {
          setHasSearchHits(false)
          postNoHitsMessage()
        }
        return
      }

      const currentHits = (response.data.hits || []).map(h => h.document)
      const found = response.data.found || 0
      currentNbPages.current = Math.ceil(found / HITS_PER_PAGE)
      const hasHits = !!currentHits.length
      if (isFirstPage) setHasSearchHits(hasHits)

      const facetCounts = response.data.facet_counts || []
      const categoryFacet = facetCounts.find(f => f.field_name === 'Category')
      if (categoryFacet && newCategories) {
        categoriesRef = categoryFacet.counts.map(c => [c.value, c.count])
        setCategories(categoriesRef)
      } else {
        categoriesRef = categories
      }
      const brandFacet = facetCounts.find(f => f.field_name === 'Brand')
      if (brandFacet) {
        brandsRef = brandFacet.counts.map(c => [c.value, c.count])
        setBrands(brandsRef)
      } else {
        brandsRef = brands
      }

      if (!hasHits) {
        if (isFirstPage) postNoHitsMessage()
        return
      }

      try {
        const enrichedProducts = await fetchPriceInventory({
          hits: currentHits,
          warehouse,
          companyCode: CompanyCode,
          companyId: CompanyId,
          getPrices,
          t,
        })
        if (isStale()) return

        const filtered = applyPriceFilter(enrichedProducts)
        if (isFirstPage) {
          setHasSearchHits(filtered.length > 0)
          setProducts(filtered)
          channel.postMessage({
            isLoading: false,
            listProducts: productList(filtered),
            hasSearchHits: filtered.length > 0,
            isSearchProducts: true,
          })
        } else {
          const combined = [...products, ...filtered]
          setHasSearchHits(combined.length > 0)
          setProducts(combined)
          channel.postMessage({
            isLoading: false,
            listProducts: productList(combined),
            hasSearchHits: combined.length > 0,
            isSearchProducts: true,
          })
        }
        setNewCategories(false)
      } catch (_err) {
        setNewCategories(true)
        if (!isStale() && isFirstPage) {
          setHasSearchHits(false)
          postNoHitsMessage()
        }
      }
    } catch (error) {
      console.error('Error getting products:', error)
      if (!isStale() && currentPage.current === 0) {
        setHasSearchHits(false)
        postNoHitsMessage()
      }
    } finally {
      if (!isStale()) setProductsLoading(false)
    }
  }

  useEffect(() => {
    currentPage.current = 0
  }, [CompanyCode])

  useEffect(() => {
    setHasMore(false)
    if (
      (productSearch && isSearchable && !showDepartments) ||
      (searchTrigger && isSearchable && !showDepartments) ||
      (categories && isSearchable && !showDepartments) ||
      (brands && isSearchable && !showDepartments) ||
      (priceFiltersState !== '' &&
        categorySearchTrigger &&
        isSearchable &&
        !showDepartments)
    ) {
      ;(async () => {
        await fetchProducts()
        const currentPagination = currentPage.current
        if (currentNbPages.current > currentPagination + 1) {
          setHasMore(true)
        }
      })()
    }
  }, [
    productSearch,
    page,
    searchTrigger,
    categorySearchTrigger,
    currentCategory,
    priceFiltersState,
    priceFilterTrigger,
    brandSearchTrigger,
    currentBrand,
    CompanyCode,
  ])

  useEffect(() => {
    dispatch(showProductsList(true))
    dispatch(clearList())
    onListCleared?.()
    return () => {
      // Marks any in-flight request as stale so a late response can't
      // call postMessage on the channel we're about to close.
      requestIdRef.current++
      channelRef.current?.close()
    }
  }, [])

  const renderFilterItems = (
    items,
    onChange,
    checkedSet,
    testIdPrefix,
    limit
  ) => {
    const displayItems = limit
      ? [...items].sort().slice(0, limit)
      : [...items].sort()
    return displayItems.map(item => (
      <div
        className="product-category"
        key={item[0]}
        data-testid={`container-${testIdPrefix}-${toTestId(item[0])}`}>
        <input
          type="checkbox"
          name={item[0]}
          id={item[0]}
          value={item[0]}
          checked={checkedSet.has(item[0])}
          onChange={onChange}
          data-testid={`input-${testIdPrefix}-${toTestId(item[0])}`}
        />
        <label htmlFor={item[0]} className="category-label">
          {item[0]} ({item[1]})
        </label>
      </div>
    ))
  }

  const handleSearchText = e => {
    setProductSearchText(e.target.value)
  }

  const handleSearch = e => {
    if (e.keyCode === 13 && productSearchText.trim().length) {
      if (e.target.value && e.target.value !== productSearch) {
        handleRemoveDepartment(false)
        setShowDepartments(false)
        setProducts([])
        currentPage.current = 0
        setNewCategories(true)
        setProductSearch(e.target.value)
      } else if (e.target.value === '' && productSearch !== '') {
        setShowDepartments(false)
        setProducts([])
        currentPage.current = 0
        setNewCategories(true)
        setProductSearch(e.target.value)
      }
      setIsSearchable(true)
    }
  }

  const searchTextRef = useRef(null)

  const handleSearchTextInput = value => {
    if (value !== '' && productSearchText.trim().length) {
      if (value && value !== productSearch) {
        handleRemoveDepartment(false)
        setShowDepartments(false)
        setProducts([])
        currentPage.current = 0
        setNewCategories(true)
        setProductSearch(value)
      } else if (value === '' && productSearch !== '') {
        setShowDepartments(false)
        setProducts([])
        currentPage.current = 0
        setNewCategories(true)
        setProductSearch(value)
      }
      setIsSearchable(true)
    }
  }

  const handleRemoveDepartment = textOverride => {
    if (textOverride) {
      setProductSearch('')
      setProductSearchText('')
    }
    setCurrentDepartment(null)
    setCurrentCategory([])
    setCheckedCategories(new Set())
    setCheckedBrands(new Set())
    setCategories([])
    dispatch(removeFacetFilters())
    setNewCategories(true)
    setBrands([])
    setShowDepartments(true)
    setSearchTrigger(false)
    setProducts([])
    setShowFullCategories(false)
    setShowFullBrands(false)
    setCurrentBrand([])
    setPriceFiltersState('')
    setHasSearchHits(true)
    setIsSearchable(false)
    priceChecked.current = 0
    currentPage.current = 0
  }

  const categoryLimit = showFullCategories ? undefined : 8
  const brandLimit = showFullBrands ? undefined : 8

  return (
    <div
      className={
        inListScreen
          ? 'productos-cotizacion-listScreen'
          : 'productos-cotizacion'
      }
      data-testid="container-product-search">
      <div className="productos-cotizacion-header">
        <div className="productos-cotizacion-search">
          <div
            className="search-bar-input"
            data-testid="container-search-input">
            <input
              ref={searchTextRef}
              className="search-product"
              type="text"
              disabled={productsLoading}
              value={productSearchText}
              onChange={handleSearchText}
              onKeyDown={handleSearch}
              placeholder="Busca un producto ingresando su descripción, código, marca o número de parte"
              data-testid="input-search"
            />
            <img
              src={search}
              className="cotizacion-search-icon"
              alt="search"
              data-testid="btn-search-products"
              onClick={() => handleSearchTextInput(searchTextRef.current.value)}
            />
          </div>
          {!showDepartments && (
            <button
              className={
                !isActive || !currentCategory.length ? 'active-slider' : ''
              }
              disabled={productsLoading}
              data-testid="btn-filter-toggle"
              onClick={handleSlider}>
              <img
                className={isActive || currentCategory.length ? 'blue-svg' : ''}
                src={Slider}
                alt="slider"
              />
            </button>
          )}
          <div
            className={'filtering-options'}
            style={{
              display: isActive ? '' : 'none',
              overflowY: 'scroll',
              height: 'calc(93vh - 200px)',
            }}
            onMouseLeave={() => setIsActive(false)}
            data-testid="container-filtering-options">
            <div
              style={{
                marginBottom: '11px',
                border: '1px solid #DBDBDB',
                padding: '29px 50px',
                backgroundColor: '#fff',
              }}
              data-testid="container-category-filters">
              <h3>Categorías</h3>
              {categories?.length
                ? renderFilterItems(
                    categories,
                    handleCategory,
                    checkedCategories,
                    'category',
                    categoryLimit
                  )
                : null}
              {categories?.length > 7 && (
                <Link
                  to="#"
                  className="categories-ver-todas"
                  data-testid="link-toggle-categories"
                  onClick={() => setShowFullCategories(!showFullCategories)}>
                  {showFullCategories ? 'Ver menos' : 'Ver Todas'}
                </Link>
              )}
            </div>
            <div
              style={{
                marginBottom: '11px',
                border: '1px solid #DBDBDB',
                padding: '29px 50px',
                backgroundColor: '#fff',
              }}
              data-testid="container-brand-filters">
              <h3>Marcas</h3>
              {brands?.length
                ? renderFilterItems(
                    brands,
                    handleBrands,
                    checkedBrands,
                    'brand',
                    brandLimit
                  )
                : null}
              {brands?.length > 7 && (
                <Link
                  to="#"
                  className="categories-ver-todas"
                  data-testid="link-toggle-brands"
                  onClick={() => setShowFullBrands(!showFullBrands)}>
                  {showFullBrands ? 'Ver menos' : 'Ver Todas'}
                </Link>
              )}
            </div>
            <div
              style={{
                marginBottom: '11px',
                border: '1px solid #DBDBDB',
                padding: '29px 50px',
                backgroundColor: '#fff',
              }}
              data-testid="container-price-filters">
              <h3>Precios</h3>
              <div className="product-category">
                <input
                  type="checkbox"
                  name="priceFilterOption"
                  value="Company.FinalPrice: 0 TO 19.99"
                  onChange={() => {}}
                  onClick={handlePriceFilter}
                  checked={priceChecked.current === 1}
                  data-testid="input-price-filter-0-19"
                />
                <label className="category-label">Desde $0 a $19.99</label>
              </div>
              <div className="product-category">
                <input
                  type="checkbox"
                  name="priceFilterOption"
                  value="Company.FinalPrice: 20 TO 199"
                  onChange={() => {}}
                  onClick={handlePriceFilter}
                  checked={priceChecked.current === 2}
                  data-testid="input-price-filter-20-199"
                />
                <label className="category-label">Desde $20 a $199</label>
              </div>
              <div className="product-category">
                <input
                  type="checkbox"
                  name="priceFilterOption"
                  value="Company.FinalPrice: 200 TO 499"
                  onChange={() => {}}
                  onClick={handlePriceFilter}
                  checked={priceChecked.current === 3}
                  data-testid="input-price-filter-200-499"
                />
                <label className="category-label">Desde $200 a $499</label>
              </div>
              <div className="product-category">
                <input
                  type="checkbox"
                  name="priceFilterOption"
                  value="Company.FinalPrice: 500 TO 799"
                  checked={priceChecked.current === 4}
                  onChange={() => {}}
                  onClick={handlePriceFilter}
                  data-testid="input-price-filter-500-799"
                />
                <label className="category-label">Desde $500 a $799</label>
              </div>
              <div className="product-category">
                <input
                  type="checkbox"
                  name="priceFilterOption"
                  checked={priceChecked.current === 5}
                  value="Company.FinalPrice >= 800"
                  onChange={() => {}}
                  onClick={handlePriceFilter}
                  data-testid="input-price-filter-800-plus"
                />
                <label className="category-label">$800+</label>
              </div>
              <div>
                <input
                  className="min-max"
                  placeholder="$ Min"
                  value={minInput}
                  onChange={e => setMinInput(e.target.value)}
                  onKeyDown={handleMinMax}
                  data-testid="input-price-min"></input>
                <p
                  style={{
                    fontSize: '20px',
                    display: 'inline-block',
                    marginRight: '10px',
                    marginLeft: '10px',
                  }}>
                  -
                </p>
                <input
                  className="min-max"
                  placeholder="$ Max"
                  value={maxInput}
                  onChange={e => setMaxInput(e.target.value)}
                  onKeyDown={handleMinMax}
                  data-testid="input-price-max"></input>
              </div>
            </div>
          </div>
        </div>
        <div
          className="current-filtering-options"
          style={{
            display: currentCategory ? 'flex' : 'none',
            flexWrap: 'nowrap',
            overflowX: 'auto',
          }}
          data-testid="container-active-filters">
          {currentDepartment && (
            <div
              className="current-filtering-option"
              data-testid="active-department-filter">
              <span>Departamento: {currentDepartment}</span>
              <img
                src={no}
                alt="close"
                onClick={() => handleRemoveDepartment(true)}
                data-testid="img-remove-department-filter"
              />
            </div>
          )}
          {currentCategory?.length > 0 &&
            currentCategory.map(category => {
              return (
                <div
                  className="current-filtering-option"
                  key={category}
                  data-testid={`card-active-category-filter-${toTestId(
                    category
                  )}`}>
                  <span>{category}</span>
                  <img
                    src={no}
                    alt="close"
                    onClick={() => handleRemoveCategory(category)}
                    data-testid={`img-remove-category-filter-${toTestId(
                      category
                    )}`}
                  />
                </div>
              )
            })}
          {currentBrand?.length > 0 &&
            currentBrand.map(brand => {
              return (
                <div
                  className="current-filtering-option"
                  key={brand}
                  data-testid={`card-active-brand-filter-${toTestId(brand)}`}>
                  <span>{brand}</span>
                  <img
                    src={no}
                    alt="close"
                    onClick={() => handleRemoveBrand(brand)}
                    data-testid={`img-remove-brand-filter-${toTestId(brand)}`}
                  />
                </div>
              )
            })}
        </div>
      </div>
      <div
        id="scrollableDiv"
        className={
          showDepartments
            ? 'productos-cotizacion-departments'
            : isSearchable
            ? hasSearchHits
              ? 'products-cotizacion-content-container'
              : 'cotizacion-content-message'
            : 'cotizacion-content-message'
        }
        data-testid="container-product-results">
        {showDepartments ? (
          <>
            <Departments
              handleDepartmentSearch={handleDepartmentSearch}
              setShowDepartments={setShowDepartments}
            />
          </>
        ) : isSearchable ? (
          <>
            <ProductList
              hasSearchHits={hasSearchHits}
              products={products}
              setPage={setPage}
              productsRef={productsRef}
              productsLoading={productsLoading}
              hasMore={hasMore}
              handlePage={handlePage}
              inListScreen={inListScreen}
              currentCategory={currentCategory}
              productSearchText={productSearchText}
              setShowMaterialsCalculatorPDP={setShowMaterialsCalculatorPDP}
              setProductDetail={setProductDetail}
            />
          </>
        ) : (
          <div className="add-products-quote-message">
            <MiniLoading productsLoading={productsLoading} />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProductSearch
